import { TransactionState } from "../openapi/webservice";

export function isInProgress(state: TransactionState) {
    return state === TransactionState.InProgress;
}
